// React and related imports
import React from 'react';

// Interfaces
import { IMedia } from '../../common/interfaces/Media.interface';

// Custom Components
import { MediaThumbnail } from '../MediaGallery/MediaThumbnail';
import { SelectIndicator } from '../MediaGallery/SelectIndicator';

interface MediaGalleryGridProps {
  items: IMedia[];
  selectedMedia?: IMedia;
  onSelect: (media: IMedia | null) => void;
  onPreview: (media: IMedia) => void;
}

export const MediaGalleryGrid: React.FC<MediaGalleryGridProps> = ({
  items,
  selectedMedia,
  onSelect,
  onPreview,
}) => {
  const isMediaSelected = (item: IMedia) => selectedMedia?.id === item.id;

  return (
    <div className="grid grid-cols-2 gap-2 p-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8">
      {items.map((item) => (
        <div
          key={item.id}
          className={`group relative aspect-square transform cursor-pointer overflow-hidden rounded-lg shadow-sm transition-all duration-200 ease-in-out hover:z-10 hover:scale-[1.02] hover:shadow-md ${
            isMediaSelected(item) ? 'ring-2 ring-primary-500 ring-offset-2' : ''
          }`}
          onClick={() => onPreview(item)}
        >
          {/* Media Thumbnail */}
          <MediaThumbnail item={item} />

          {/* Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/0 via-black/0 to-black/50 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />

          {/* Select Indicator */}
          <div
            className="absolute left-2 top-2 z-10"
            onClick={(e) => {
              e.stopPropagation();
              if (isMediaSelected(item)) {
                onSelect(null);
              } else {
                onSelect(item);
              }
            }}
          >
            <SelectIndicator isSelected={isMediaSelected(item)} />
          </div>

          {/* Media Name */}
          <div className="absolute bottom-0 left-0 right-0 z-10 p-2">
            <h3 className="truncate text-sm font-medium text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">
              {item.name}
            </h3>
          </div>
        </div>
      ))}
    </div>
  );
};
